import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { InputBox, Button } from "../../Common";
import { createNewInvestingPartner, updateInvestingPartner, UploadDocument } from "../../api";
import styles from "./partners.module.css";
import { validatePartnerForm } from "../../utils/validation";
import DropDown from "../../Common/DropDown/index";
import { CookieUtils } from "../../axios.config";
export const AddPartner = ({
  mode = "create",
  initialData,
  newPartnerAdded,
  userName,
}) => {
  const initialFormData = {
    name: "",
    code: "",
    host: "",
    logo: "",
    // location: "",
    description: "",
    status: "inactive",
    createdBy: "",
    updatedBy: "",
    type: [],
    scopes: [],
  };

  const [formData, setFormData] = useState(initialData || initialFormData);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [logoLoading, setLogoLoading] = useState(false);
  const statusList = ["active", "inactive"];
  // const locationList = ["India", "MENA"];

  const getCurrentUsername = () => {
    if (userName) return userName;

    const cookieUserName = CookieUtils.get("username");
    if (cookieUserName) {
      try {
        return JSON.parse(cookieUserName);
      } catch {
        return cookieUserName;
      }
    }

    return "system";
  };


  useEffect(() => {
    const currentUsername = getCurrentUsername();

    if (mode === "update" && initialData) {
      setFormData({
        ...initialData,
        type: initialData.type || [],
        updatedBy: currentUsername,
      });
    } else {
      setFormData({
        ...initialFormData,
        createdBy: currentUsername,
      });
    }
  }, [userName, mode, initialData]);


  const normalizeHost = (input, { finalize = false } = {}) => {
    let v = String(input ?? "").trim().toLowerCase();
    if (!v) return "";

    v = v.replace(/^[a-z][a-z0-9+.-]*:\/\//, "");
    v = v.replace(/^\/\//, "");
    v = v.replace(/^\.+/, "");
    v = v.replace(/.*@/, "");
    v = v.split(/[/?#]/)[0];
    v = v.replace(/^www\d*\./, "");
    v = v.split(":")[0];

    if (finalize) {
      v = v.replace(/\.+$/, "");
    }

    return v;
  };

  const handleHostChange = (e) => {
    const { name, value } = e.target;
    const normalized = normalizeHost(value);
    setFormData({ ...formData, [name]: normalized });
    setErrors({ ...errors, [name]: "" });
  };

  const handleHostBlur = (e) => {
    const { name, value } = e.target;
    const normalized = normalizeHost(value, { finalize: true });
    if (normalized !== value) {
      setFormData({ ...formData, [name]: normalized });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

 if (name === "code") {
    const alphabetValue = value.replace(/[^a-zA-Z\_]/g, "");
    setFormData({
      ...formData,
      [name]: alphabetValue.toUpperCase(),
    });
  } else if (type === "checkbox") {
    setFormData({
      ...formData,
      [name]: checked,
    });
  } else {
    setFormData({ ...formData, [name]: value });
  }

  setErrors({ ...errors, [name]: "" });
};

  const handleDropdownChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const newErrors = validatePartnerForm(formData, mode);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      ...initialFormData,
      createdBy: formData.createdBy,
    });
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    setLoading(true);

    try {
      let partnerCode = formData.code.replace(/ /g, "_");
        // if (formData.location === "MENA") {
        //   partnerCode = partnerCode + "-GLOBAL";
        // }
      const apiData = {
        name: formData.name,
        code: partnerCode,
        host: normalizeHost(formData.host, { finalize: true }),
        logo: formData.logo,
        // location: formData.location,
        description: formData.description,
        status: formData.status,
        type: formData.type,
        ...(mode === "create"
          ? { createdBy: formData.createdBy }
          : { updatedBy: userName || formData.updatedBy || "system" }),
        scopes: formData.scopes,
      };


      const response =
        mode === "create"
          ? await createNewInvestingPartner(apiData)
          : await updateInvestingPartner(
            formData.partnerCd || formData.code,
            apiData,
            formData
          );

      setLoading(false);

      if (response?.status === 200 || response?.code === 200) {
        setSuccessMessage(
          mode === "create"
            ? "Partner created successfully!"
            : "Partner updated successfully!"
        );

        resetForm();

        setTimeout(() => {
          setSuccessMessage("");
          newPartnerAdded();
        }, 3000);
      } else if (response?.status === 400) {
        setErrors({
          form:
            response.data.message ||
            "Partner already exists with the given Partner code.",
        });
      } else {
        setErrors({ form: response?.message || "Operation failed!" });
      }
    } catch (error) {
      setLoading(false);
      setErrors({
        form: error.message || "An error occurred. Please try again.",
      });
    }
  };
  const ShowLogoField = () => {
  const types = formData.type || [];
  return types.includes("whiteLabelled") || types.includes("referral");
  };
  const ShowHostField = () => {
    const types = formData.type || [];
    return types.includes("whiteLabelled");
  };

  const ShowScopes = () => {
    return (formData.type || []).includes("api");
  };

  const scopeOptions = [
    "cancel-stock-order",
    "create-etf-order",
    "create-fund-order",
    "create-lrs",
    "create-redemption",
    "create-stack-order",
    "create-stock-order",
    "create-user",
    "get-instr",
    "get-lrs",
    "get-order",
    "get-position",
    "get-redemption",
    "get-stack",
    "get-stmt",
    "get-user",
    "kyc",
    "subscribe-plan",
    "update-user",
    "price",
    "price-chart"
  ];
  const handleLogoChange = async (e, setFormData, setErrors) => {
    const file = e.target.files[0];
    if (file) {
      const formDataUpload = new FormData();
      formDataUpload.append("file", file);
      setLogoLoading(true);

      try {
        const res = await UploadDocument(formDataUpload);
        if (res?.status === 200 && res?.data?.data) {
          setFormData((prev) => ({
            ...prev,
            logo: res.data.data,
          }));
          setErrors((prev) => ({ ...prev, logo: "" }));
        } else {
          setErrors((prev) => ({ ...prev, form: res?.data?.message || "Logo upload failed." }));
        }
      } catch (err) {
        setErrors((prev) => ({ ...prev, form: err?.response?.data?.message || err?.message || "Something went wrong while uploading logo." }));
      }
      setLogoLoading(false);
    }
  };
  return (
    <div className={styles.Container}>
      <div className={styles.partnerFormContainer}>
        <h3>{mode === "create" ? "Add Partner" : "Update Partner"}</h3>
        <form>
          <Row className="mb-4">
            <Col md={12} className={styles.inputDiv}>
              <label>
                Partner Type <span className={styles.required}>*</span>
              </label>
              <Row>
                {["whiteLabelled", "api", "referral"].map((option) => (
                  <Col md={4} key={option}>
                    <label>
                      <input
                        type="checkbox"
                        name="type"
                        value={option}
                        checked={(formData.type || []).includes(option)}
                        onChange={(e) => {
                          const value = e.target.value;
                          const checked = e.target.checked;
                          const updatedType = checked
                            ? [...formData.type, value]
                            : formData.type.filter((t) => t !== value);

                          setFormData({ ...formData, type: updatedType });
                        }}
                      />
                      {" " + option}
                    </label>
                  </Col>
                ))}
              </Row>
              {errors.type && <p className={styles.errorMessage}>{errors.type}</p>}
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={4} className={styles.inputDiv}>
              <label>
                Partner Name <span className={styles.required}>*</span>
                <InputBox
                  placeholder="Enter Partner Name"
                  type="text"
                  name="name"
                  onChange={handleChange}
                  value={formData.name ?? ""}
                // disabled={mode === "update"}
                />
                {errors.name && <p className={styles.errorMessage}>{errors.name}</p>}
              </label>
            </Col>
            <Col md={4} className={styles.inputDiv}>
              <label>
                Partner Code <span className={styles.required}>*</span>
                <InputBox
                  placeholder="Enter Partner Code"
                  type="text"
                  name="code"
                  onChange={handleChange}
                  value={formData.code ?? ""}
                  disabled={mode === "update"}
                />
                {errors.code && <p className={styles.errorMessage}>{errors.code}</p>}
              </label>
            </Col>
            <Col md={4} className={styles.inputDiv}>
                <DropDown
                  label="Status"
                  name="status"
                  value={formData.status}
                  data={statusList}
                  onChange={(val) => handleDropdownChange("status", val)}
                  placeholder="Select Status"
                  required={true}
                  error={!!errors.status}
                  helperText={errors.status}
                />
            </Col>
          </Row>
           <Row className="mb-4">
            {/* <Col md={4} className={styles.inputDiv}>
               <DropDown
              label="Location"
              name="location"
              value={formData.location}
              data={locationList}
              onChange={(val) => handleDropdownChange("location", val)}
              placeholder="Select Location"
              required={true}
              error={!!errors.location}
              helperText={errors.location}
            />
            </Col> */}
                {ShowLogoField() && (
                  <Col md={4} className={styles.inputDiv}>
                    <label>
                      Logo Upload <span className={styles.required}>*</span>
                      <InputBox
                        type="text"
                        name="logo"
                        value={formData.logo || ""}
                        disabled
                        placeholder="Upload Logo"
                      />
                      {errors.logo && <p className={styles.errorMessage}>{errors.logo}</p>}
                    </label>

                    <div className={styles.logoButtonWrapper}>
                      {logoLoading ? (
                        <Button loading={true} title="Uploading..." disabled />
                      ) : (
                        <label className={styles.chooseBtn}>
                          Choose Logo
                          <input
                            type="file"
                            accept=".png,.jpg,.jpeg,.svg"
                            onChange={(e) => handleLogoChange(e, setFormData, setErrors)}
                            className={styles.hiddenInput}
                          />
                        </label>
                      )}
                      {formData.logo && (
                        <a
                          href={formData.logo}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.viewBtn}
                        >
                          View
                        </a>
                      )}
                    </div>
                  </Col>
                )}
            {ShowHostField() && (
              <Col md={4} className={styles.inputDiv}>
                <label>
                  Host <span className={styles.required}>*</span>
                  <InputBox
                    placeholder="Enter Host URL"
                    type="text"
                    name="host"
                    onChange={handleHostChange}
                    onBlur={handleHostBlur}
                    value={formData.host ?? ""}
                  />
                  {errors.host && <p className={styles.errorMessage}>{errors.host}</p>}
                </label>
              </Col>
            )}

            {ShowScopes() && (
              <Col md={8} className={styles.inputDiv}>
                <DropDown
                  label="Scopes"
                  name="scopes"
                  value={formData.scopes}
                  data={scopeOptions}
                  onChange={(val) => setFormData({ ...formData, scopes: val })}
                  placeholder="Select API scopes"
                  required={true}
                  error={!!errors.scopes}
                  helperText={errors.scopes}
                  isMulti={true}
                />
              </Col>
            )}
          </Row>
          
          <Row className="mb-4">
            <Col md={12} className={styles.inputDiv}>
              <label>
                Description <span className={styles.required}>*</span>
                <textarea
                  placeholder="Enter Description"
                  name="description"
                  className={styles.textArea}
                  onChange={handleChange}
                  value={formData.description ?? ""}
                />
                {errors.description && <p className={styles.errorMessage}>{errors.description}</p>}
              </label>
            </Col>
          </Row>

          {successMessage && (
            <h4
              style={{
                textAlign: "center",
                fontSize: "20px",
                color: "green",
                fontWeight: "bold",
                margin: "20px 0",
              }}
            >
              {successMessage}
            </h4>
          )}

          {errors.form && (
            <p style={{ color: "red", textAlign: "center" }}>{errors.form}</p>
          )}

          <Row style={{ marginBottom: "20px" }}>
            <Col md={12} className={styles.buttonContainer}>
              <div className={styles.centeredButtons}>
                <Button
                  onClick={handleSubmit}
                  disabled={loading || successMessage !== ""}
                  loading={loading}
                  title={mode === "create" ? "Submit" : "Update"}
                />
              </div>
            </Col>
          </Row>
        </form>
      </div>
    </div>
  );
};

export default AddPartner;